export const DATE_SHORT = "DATE_SHORT";
export const DATETIME_SHORT = "DATETIME_SHORT";
export const DATETIME_SHORT_WITH_SECONDS = "DATETIME_SHORT_WITH_SECONDS";
export const TIME_SIMPLE = "TIME_SIMPLE";
export const TIME_24_WITH_SECONDS = "TIME_24_WITH_SECONDS";
